/* Text styles */
._form_1p9ud_2 {
  display: flex;
  gap: 20px;
}